import { ServerCmdProviderBase } from '../../core/cmd/ServerCmdProviderBase.js';
import { findBySearchMask } from '../../core/imcmd/SearchMask.js';
import { TableServerCommand } from './TableServerCommand.js';

// src/widgets/table/TableServerCmdProvider.ts
/**
 * Провайдер серверных команд для TableWidget.
 * Делегирует операции в items:: namespace (ItemsUiCommandProvider).
 */
class TableServerCmdProvider extends ServerCmdProviderBase {
    constructor() {
        super(...arguments);
        /** Уникальный ключ провайдера */
        this.id = "TableWidget";
        /** Приоритет обработки */
        this.priority = 0;
    }
    /** Поддерживаемые типы серверных команд */
    getSupported() {
        return [
            TableServerCommand.reloadTable,
        ];
    }
    /**
     * Адаптирует серверные команды таблицы в UI-токены (namespace = items).
     */
    adapt(cmd, _ctx) {
        const t = [];
        switch (cmd.type) {
            case TableServerCommand.reloadTable:
                {
                    const maskStr = (cmd.mask ?? `@${cmd.tableKey}`);
                    this.makeMaskStr;
                    const mask = this.makeMask(maskStr, cmd.area, true);
                    const items = findBySearchMask(_ctx.viewHost, mask, _ctx.sourceEl, _ctx.uiNotMask);
                    t.push({
                        raw: "items::reloadAll",
                        namespace: "items",
                        command: "reloadAll",
                        rawArgs: [],
                        solvedArgs: { indexes: cmd.rowID },
                        targetItems: items
                    });
                }
                break;
        }
        return this.makeResult(t);
    }
}

export { TableServerCmdProvider };
